import React from 'react'
import { withRouter } from "react-router";

class SearchBar extends React.Component {

    constructor() {
        super()
        this.state = {
            isOpen: false,
            searchValue: "",
        }
        this.inputRef = React.createRef()
    }

    handleValueChange = async (e) => {
        e.preventDefault()
        await this.setState({ searchValue: e.target.value })
    }

    handleInputToggle = async () => {
        let input = document.getElementById("search-id")
        await this.setState({ isOpen: !this.state.isOpen })
        if (!this.state.isOpen) {
            input.style.width = "0px"
            input.style.padding = 0
        } else {
            input.style.width = "120px"
            input.style.padding = "2px"
        }
    }

    handleSearchSubmit = (e) => {
        e.preventDefault()
        this.props.history.push("/search/" + this.state.searchValue)
    }

    render() {
        const { openLeft } = this.props
        return (
            <>
                <li style={openLeft ? {flexDirection: 'row-reverse'} : {flexDirection: 'row'}}>
                    <i className="fas fa-search" onClick={this.handleInputToggle} ></i>
                    <form onSubmit={this.handleSearchSubmit}>
                        <input id="search-id" style={{ width: 0 }} className="search-input" type="text" onChange={this.handleValueChange} />
                    </form>
                </li>
            </>
        )
    }
}

export default withRouter(SearchBar)